import VueRouter from "vue-router";
import Vue from "vue";
import config from "./config";
// import store from "../store";

//1. 安装
Vue.use(VueRouter);

//2. 创建路由对象
var router = new VueRouter(config);
// 导航守位 拦截
// router.beforeEach(function(to, from, next) {
//   const access_token =
//     JSON.parse(localStorage.getItem("userInfo"))?.access_token || null;
//   console.log("access_token===========", access_token);
//   if (to.name !== "Login") {
//     // 需要登录才能访问页面
//     if (access_token) {
//       // if (access_token) {
//       next(); //允许进入
//     } else {
//       console.log("token错误");
//       next({
//         name: "Login",
//       });
//     }
//   } else {
//     next();
//   }
// });

export default router;
